/**
 * Shared display helpers for Bilt QR / share / sticker surfaces.
 * Keeps URL labels and brand asset paths consistent across canvases.
 *
 * Lockup master: `web/public/brand/source/bilt-spec-lockup-master.png`
 * (B-mark + BiLT + :SPEC). Prefer that PNG / derived sizes for new artwork.
 */

/** Black-on-transparent B-mark for vinyl lockups and dark-on-light UI. */
export const BILT_MARK_MONO_SRC = '/brand/bilt-mark-mono.png';

/** White-on-transparent badge (square B-mark) for compact dark surfaces. */
export const BILT_BADGE_SRC = '/brand/bilt-badge.png';

/**
 * Official horizontal lockup (B-mark + BiLT + :SPEC), metallic on transparent.
 * Use for dark UI and general artwork. Master: brand/source/bilt-spec-lockup-master.png
 */
export const BILT_LOCKUP_SRC = '/brand/bilt-lockup.png?v=20260826';

/**
 * White + orange horizontal lockup for black vinyl (Passport stickers).
 * Same geometry as BILT_LOCKUP_SRC; orange bar and :SPEC preserved.
 */
export const BILT_LOCKUP_WHITE_SRC = '/brand/bilt-lockup-white.png?v=20260826';

/** Default print/share accent (Bilt orange). Accents never tint QR modules. */
export const BILT_ACCENT_DEFAULT = '#f97316';

/**
 * Normalize a share URL into the uppercase build path shown under branded QRs,
 * e.g. "BILTSPEC.COM/USER/BUILD".
 */
export function formatBiltBuildUrlLabel(urlOrPath: string): string {
  const trimmed = (urlOrPath || '').trim();
  if (!trimmed) return 'BILTSPEC.COM';
  try {
    const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const parsed = new URL(withScheme);
    const host = parsed.hostname.replace(/^www\./i, '').toUpperCase();
    const path = parsed.pathname.replace(/\/+$/, '').replace(/^\//, '').toUpperCase();
    return path ? `${host}/${path}` : host;
  } catch {
    return trimmed
      .replace(/^https?:\/\//i, '')
      .replace(/^www\./i, '')
      .replace(/\/+$/, '')
      .toUpperCase();
  }
}
